import domReady from '../helpers/dom-ready';

class LeftMenu {
  static init() {
    const nav = document.querySelector('.side-menu.-panel');
    return nav ? new LeftMenu(nav) : null;
  }

  constructor(nav) {
    this.nav = nav;
    this.toggle = nav.querySelector('.area-menu__toggle');
    this.subToggles = [...nav.querySelectorAll('.area-menu__sub-toggle')];

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen()));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.setOpen(false);
          this.toggle.focus();
        }
      });

      document.addEventListener('click', (e) => {
        if (this.isOpen() && !this.nav.contains(e.target)) {
          this.setOpen(false);
        }
      });
    }

    this.subToggles.forEach((button) => {
      button.addEventListener('click', () => this.toggleSub(button));
    });

    this.initStickyColumn();
  }

  // The nav column must be as tall as <main> for the sticky menu to travel alongside the content.
  initStickyColumn() {
    const main = this.nav.nextElementSibling;
    if (!main || main.tagName !== 'MAIN' || !('ResizeObserver' in window)) {
      return;
    }

    const desktop = window.matchMedia('(min-width: 1107px)');
    const update = () => {
      if (!desktop.matches) {
        this.nav.style.minHeight = '';
        return;
      }
      const height = main.getBoundingClientRect().bottom - this.nav.getBoundingClientRect().top;
      this.nav.style.minHeight = `${Math.max(0, height)}px`;
    };

    new ResizeObserver(update).observe(main);
    desktop.addEventListener('change', update);
    update();
  }

  isOpen() {
    return this.nav.classList.contains('-is-open');
  }

  setOpen(open) {
    this.nav.classList.toggle('-is-open', open);
    this.toggle.setAttribute('aria-expanded', String(open));
  }

  toggleSub(button) {
    const expand = button.getAttribute('aria-expanded') !== 'true';

    this.subToggles.forEach((other) => {
      if (other !== button) {
        LeftMenu.setSub(other, false);
      }
    });
    LeftMenu.setSub(button, expand);
  }

  static setSub(button, expand) {
    const list = document.getElementById(button.getAttribute('aria-controls'));

    button.setAttribute('aria-expanded', String(expand));
    if (list) {
      list.hidden = !expand;
    }
  }
}

domReady(() => {
  LeftMenu.init();
});
